module.exports = __webpack_public_path__ + "src/assets/img/truck1.9067d0cb.png";